import { render, staticRenderFns } from "./AlfListings.vue?vue&type=template&id=51060746"
import script from "./AlfListings.vue?vue&type=script&lang=js"
export * from "./AlfListings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports